var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSection8Feat2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.33464 49.0003C8.05131 49.0003 6.95231 48.543 6.03764 47.6283C5.12297 46.7137 4.66642 45.6154 4.66797 44.3337V18.667C4.66797 17.3837 5.12531 16.2847 6.03997 15.37C6.95464 14.4553 8.05286 13.9988 9.33464 14.0003H18.668V9.33366C18.668 8.05033 19.1253 6.95133 20.04 6.03666C20.9546 5.122 22.0529 4.66544 23.3346 4.667H32.668C33.9513 4.667 35.0503 5.12433 35.965 6.039C36.8796 6.95366 37.3362 8.05189 37.3346 9.33366V14.0003H46.668C47.9513 14.0003 49.0503 14.4577 49.965 15.3723C50.8796 16.287 51.3362 17.3852 51.3346 18.667V44.3337C51.3346 45.617 50.8773 46.716 49.9626 47.6307C49.048 48.5453 47.9497 49.0019 46.668 49.0003H9.33464ZM9.33464 44.3337H46.668V18.667H9.33464V44.3337ZM23.3346 14.0003H32.668V9.33366H23.3346V14.0003Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSection8Feat2);
export default __webpack_public_path__ + "static/media/section8Feat2.6dc3611b8367c2877bdf32ad56777451.svg";
export { ForwardRef as ReactComponent };